import axios from 'axios';
import {backendHost} from '../../config';

const getAuthorization = () => {
    return axios.get(`${backendHost}/api/admin/auth`);
};

export {
    getAuthorization
}